import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { ProductImagesDirective } from './product-images.directive';
export var ProductImagesComponentNgModule = module(baseModuleId + ".product-images", [])
    .directive('productImages', ProductImagesDirective)
    // Backward compatibility to alread used typo.
    .directive('priductImages', ProductImagesDirective);
